import Axios from 'axios';

export function validateToken(token) {
    return Axios.get(
      '/api/user/validate',
      { headers: { 'Authentication': `Bearer ${token}` }}
    )
  }